export interface ShipplayPrivacyContent {
  title: string
}

export const shipplayContent: ShipplayPrivacyContent = {
  title: 'Privacy Policy',
}
